import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { CAMPAIGN_FORM_KEYS as FORM_KEYS } from 'dash-front/constants';

const mapStateToProps = (formName, key) => {
    if (formName === undefined) {
        throw new Error('formName is undefined in withTriggerType enhancer');
    }
    const valueSelector = formValueSelector(formName);
    return state => {
        const triggerType = valueSelector(state, key);
        return { triggerType };
    };
};

const withTriggerType = (formName, key = FORM_KEYS.RULES.KEY) =>
    connect(mapStateToProps(formName, key));

export default withTriggerType;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/enhancers/withTriggerType.js
 **/